import React, { useState } from 'react';
import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';
import { CheckboxFilter } from '@folio/stripes/smart-components';
import { Headline, TextField } from '@folio/stripes/components';
import { t, tString, isEditDisabled, isRefreshDisabled, isDeleteDisabled, isCancelRefreshDisabled, isCancelExportDisabled, isExportDisabled } from '../../../../services';
import { ActionMenu } from '../../../../components';
import { ICONS } from '../../../../interfaces';
import { useListAppPermissions } from '../../../../hooks';
export var ListInformationMenu = function (_a) {
    var columns = _a.columns, visibleColumns = _a.visibleColumns, conditions = _a.conditions, buttonHandlers = _a.buttonHandlers, onColumnsChange = _a.onColumnsChange;
    var permissions = useListAppPermissions();
    var isExportInProgress = conditions.isExportInProgress, isRefreshInProgress = conditions.isRefreshInProgress;
    var intl = useIntl();
    var _b = useState(''), columnSearch = _b[0], setColumnSearch = _b[1];
    var filteredColumns = columns.filter(function (item) { return item.label.toLowerCase().includes(columnSearch.toLowerCase()); });
    var allDisabled = columns.every(function (item) { return item.disabled; });
    var cancelRefreshButton = {
        label: 'cancel-refresh',
        icon: ICONS.refresh,
        onClick: buttonHandlers['cancel-refresh'],
        disabled: isCancelRefreshDisabled(conditions)
    };
    var refreshButton = {
        label: 'refresh',
        icon: ICONS.refresh,
        onClick: buttonHandlers.refresh,
        disabled: isRefreshDisabled(conditions)
    };
    var initExportButton = {
        label: 'export-visible',
        icon: ICONS.download,
        onClick: buttonHandlers['export-visible'],
        disabled: isExportDisabled(conditions)
    };
    var initExportAllButton = {
        label: 'export-all',
        icon: ICONS.download,
        onClick: buttonHandlers['export-all'],
        disabled: isExportDisabled(conditions)
    };
    var cancelExportButton = {
        label: 'cancel-export',
        icon: ICONS.download,
        onClick: buttonHandlers['cancel-export'],
        disabled: isCancelExportDisabled(conditions)
    };
    var refreshSlot = isRefreshInProgress ? (cancelRefreshButton) : (refreshButton);
    var exportSlot = isExportInProgress ? [cancelExportButton] : [initExportButton, initExportAllButton];
    var actionButtons = [];
    if (permissions.canRefresh) {
        actionButtons.push(refreshSlot);
    }
    if (permissions.canUpdate) {
        actionButtons.push({
            label: 'edit',
            icon: ICONS.edit,
            onClick: buttonHandlers.edit,
            disabled: isEditDisabled(conditions),
        });
    }
    if (permissions.canUpdate) {
        actionButtons.push({
            label: 'copy',
            icon: ICONS.duplicate,
            onClick: buttonHandlers.copy,
            disabled: false,
        });
    }
    if (permissions.canDelete) {
        actionButtons.push({
            label: 'delete',
            icon: ICONS.trash,
            onClick: buttonHandlers.delete,
            disabled: isDeleteDisabled(conditions)
        });
    }
    if (permissions.canExport) {
        actionButtons.push.apply(actionButtons, exportSlot);
    }
    return (React.createElement(ActionMenu, { actionButtons: actionButtons }, !isEmpty(columns) && (React.createElement(React.Fragment, null,
        React.createElement(TextField, { value: columnSearch, onChange: function (e) { return setColumnSearch(e.target.value); }, "aria-label": tString(intl, 'pane.dropdown.ariaLabel.columnFilter'), disabled: allDisabled, placeholder: tString(intl, 'pane.dropdown.search.placeholder') }),
        React.createElement(Headline, { size: "medium", margin: "none", tag: "p", faded: true }, t('pane.dropdown.show-columns')),
        React.createElement(CheckboxFilter, { dataOptions: filteredColumns, name: "ui-lists-columns-filter", onChange: onColumnsChange, selectedValues: visibleColumns !== null && visibleColumns !== void 0 ? visibleColumns : [] })))));
};
